<template>
  <div>
    <h3 class="modal-title"> MULTIPLE EXPERIENCE MANAGER </h3>

    <b-form-group :class="{'error-input' : $v.data_form.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_form.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.form_ui.$error}">
      <label> Select Multiple Experience Manager</label>
      <j-single-select
        v-model="$v.data_form.form_ui.$model"
        :load-options="loadOptionsFormUI"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Select Multiple Experience Manager'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.selected_view.$error}">
      <label> Select Primary View (Web) </label>
      <j-single-select
        v-model="$v.data_form.selected_view.$model"
        :options="list_view"
        label="name"
        value-format="object"
        placeholder="Select Primary View (Web)"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_form.selected_view_small.$error}">
      <label> Select Primary View (Mobile) </label>
      <j-single-select
        v-model="$v.data_form.selected_view_small.$model"
        :options="list_view_small"
        label="name"
        value-format="object"
        placeholder="Select Primary View (Mobile)"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_form: {
      title: {
        required,
      },
      form_ui: {
        required,
      },
      selected_view: {
        required,
      },
      selected_view_small: {
        required,
      },
    },
  },
  data() {
    return {
      data_form: {
        title: '',
        form_ui: null,
        selected_view: null,
        selected_view_small: null,
      },
      list_view: [],
      list_view_small: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['list_form_ui']),

    generateDataForm() {
      const dataField = {
        form_ui_id: this.data_form.form_ui.id,
        default_view: this.data_form.selected_view.id,
        default_view_small: this.data_form.selected_view_small.id,
      };

      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_form.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },

    generateDataFormUpdate() {
      const dataField = {
        form_ui_id: this.data_form.form_ui.id,
        default_view: this.data_form.selected_view.id,
        default_view_small: this.data_form.selected_view_small.id,
      };

      const data = {
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_form.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify(dataField),
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
    // eslint-disable-next-line
    'data_form.form_ui': function(data) {
      const filtered = Object.keys(data).filter(key => key.includes('view'));

      const filteredList = filtered.map(el => ({
        id: el,
        name: el.replace(/_/g, ' ').replace(/^./, el[0].toUpperCase()),
      }));

      this.list_view = filteredList.filter(e => !e.id.includes('list'));
      this.list_view_small = filteredList;
    },
  },
  mounted() {
    if (this.modeEdit) {
      const info = JSON.parse(this.dataEdit.info);
      this.data_form.title = this.dataEdit.name;

      const dataFilter = {
        id: info.form_ui_id,
      };
      const params = {
        limit: 1,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.findMultiFormUi(params).then((response) => {
        if (response) {
          const dataFormUi = response[0];
          dataFormUi.label = dataFormUi.name;
          this.data_form.form_ui = dataFormUi;
          this.data_form.selected_view = {
            id: info.default_view,
            name: info.default_view.replace(/_/g, ' ').replace(/^./, info.default_view[0].toUpperCase()),
          };
          if (info.default_view_small) {
            this.data_form.selected_view_small = {
              id: info.default_view_small,
              name: info.default_view_small.replace(/_/g, ' ').replace(/^./, info.default_view_small[0].toUpperCase()),
            };
          }
        }
      });
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm']),
    ...mapActions('jStoreFormUi', ['findMultiFormUi']),

    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetMultiFormUiListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveForm() {
      this.$v.data_form.$touch();
      if (!this.$v.data_form.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataForm,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataFormUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.data_form.title = '';
      this.data_form.form_ui = null;
      this.data_form.selected_view = null;
      this.data_form.selected_view_small = null;
      setTimeout(() => {
        this.$v.data_form.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jMultipleFormUiSetup.vue